import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import AppErrorScreen from './components/AppErrorScreen';
import reportWebVitals from './reportWebVitals';

// Error capture only for now — tracesSampleRate 0 so no performance-monitoring
// quota is spent. release matches REACT_APP_BUILD_SHA exactly (the same git
// commit SHA already baked in for the app's own build stamp, see package.json's
// build script / App.js's BUILD_SHA), so every captured error maps to a deploy.
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: 'production',
  tracesSampleRate: 0,
  release: process.env.REACT_APP_BUILD_SHA,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Names the page that failed and offers a real way out — the native app
        has no refresh gesture, so the old "please refresh the page" text was
        a dead end. See src/components/AppErrorScreen.js. */}
    <Sentry.ErrorBoundary fallback={props => <AppErrorScreen {...props} />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
